import { render, staticRenderFns } from "./BoUserLevel.vue?vue&type=template&id=5ea42635&"
import script from "./BoUserLevel.vue?vue&type=script&lang=js&"
export * from "./BoUserLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports